
import { ProFormField } from '@ant-design/pro-form';
import { AutoComplete, AutoCompleteProps } from 'antd';
import React, { FC, useEffect, useRef, useState } from 'react';
import { FormEntry } from '..';
import { useOptions } from '../utils';

interface CustomAutoCompleteProps extends AutoCompleteProps {
  name: string;
  onChange?: (value: string) => void;
  dataTid?: string;
}

export const CustomAutoComplete: FC<CustomAutoCompleteProps> = (props) => {
  const {
    onChange,
    defaultValue,
    value,
    placeholder,
    name,
    dropdownMatchSelectWidth,
    className,
    dataTid,
    onDropdownVisibleChange,
  } = props;
  const [innerValue, setInnenrValue] = useState(defaultValue);
  const [innerPlaceholder, setInnerPlaceholder] = useState(placeholder);
  const [tempValue, setTempValue] = useState(defaultValue);
  const inputRef = useRef<any>();

  // 为了模仿Select的交互
  // const [focused, setFocused] = useState(false);
  const onFilter = (inputValue: string, option: any) => !innerValue || option!.label.toUpperCase()
    .indexOf(inputValue.toUpperCase()) !== -1
  ;

  const onValueChange = (value: string) => {
    setInnenrValue(value);
    onChange?.(value);
    // 有编辑，就清空tempValue
    setTempValue('');
    if (!value) {
      setInnerPlaceholder(placeholder);
    }
  };

  // 失去焦点后，重新设置value
  const onBlur = () => {
    if (tempValue) {
      setInnenrValue(tempValue);
    }
  };

  const onFocus = () => {
    setInnerPlaceholder(innerValue || placeholder);
    setTempValue(innerValue);
    setInnenrValue('');
  };

  useEffect(() => {
    setInnenrValue(value);
  }, [value]);

  useEffect(() => {
    onDropdownVisibleChange?.(true);
  }, []);

  return (
    <AutoComplete
      ref={ref => inputRef.current = ref}
      allowClear
      options={props.options?.map(item => ({
        ...item,
        ['data-tid']: `${name}-${item.label}`,
      }))}
      filterOption={onFilter}
      placeholder={innerPlaceholder}
      value={innerValue}
      onChange={onValueChange}
      onFocus={onFocus}
      onBlur={onBlur}
      dropdownClassName={'reset-font-size'}
      className={className || 'query-form-auto-complte'}
      onSelect={() => {
        inputRef?.current.blur();
      }}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      data-tid={dataTid}
    />
  );
};

export const AutoCompleteForm: FC<{
  entry: FormEntry,
  hidden?: boolean,
}> = (props) => {
  const { entry, hidden } = props;
  const { name, label, initialValue, dropdownMatchSelectWidth, placeholder } = entry;

  const fieldKey = 'fieldKey' in entry ? (entry).fieldKey : undefined;
  const fieldScope = 'fieldScope' in entry ? (entry).fieldScope : undefined;
  const userOptions = 'options' in entry ? (entry).options : undefined;

  const options = useOptions({
    fieldKey,
    fieldScope,
    userOptions,
  });

  return (
    <ProFormField
      initialValue={initialValue}
      name={name}
      label={label}
      hidden={hidden}
      className={'custom-auto-complete'}
    >
      <CustomAutoComplete
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        name={name}
        allowClear
        placeholder={placeholder ?? '所有'}
        options={options}
        dropdownClassName={'reset-font-size'}
      />
    </ProFormField>
  );
};
